import { render, staticRenderFns } from "./DashboardConfig.vue?vue&type=template&id=7a0fe6b0&scoped=true&"
import script from "./DashboardConfig.vue?vue&type=script&lang=js&"
export * from "./DashboardConfig.vue?vue&type=script&lang=js&"
import style0 from "./DashboardConfig.vue?vue&type=style&index=0&id=7a0fe6b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0fe6b0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VBtn,VCard,VCol,VListItem,VListItemGroup,VListItemTitle,VRow,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider,VTextField,VToolbar,VVirtualScroll})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a0fe6b0')) {
      api.createRecord('7a0fe6b0', component.options)
    } else {
      api.reload('7a0fe6b0', component.options)
    }
    module.hot.accept("./DashboardConfig.vue?vue&type=template&id=7a0fe6b0&scoped=true&", function () {
      api.rerender('7a0fe6b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/DashboardConfig.vue"
export default component.exports